window.stockInventory = {

	exportCsv: function(){
		var formSerialized = $('#inventorySearchForm').serialize();
		MyFacture.relocate("stock_inventory&action=export&"+formSerialized, true);
	}

};

window.stockAlert = {

	checkPurchase: function(me){
		
		if ($('#notif-stock .alertMassPurchaseChecker:checked').length >0 ){
			$('#notif-stock .notifsMassPurchase').show();
		} else {
			$('#notif-stock .notifsMassPurchase').hide();
		}
		
	},
			
	doMassPurchase: function(){
	
		var items = new Array();
		
		$('#notif-stock .alertMassPurchaseChecker:checked').each(function(){
			items.push($(this).attr('id'));
		});
		
		DocTools.createForThird("purOrder", window.i18n.gettext("Créer un bon de commande."), undefined, items);
	}
	
};

window.Stock = {

	stockAdjustOnChild : function(){
		
		MyWindow.alert(Loc.g("Pour effectuer un mouvement de stock, rendez vous sur une fiche déclinaison."), {type:'warning'});
		
	},
	
	enableStockOnParent: function(type, id){
	
		var options = {
			type:  "warning",
			buttons : [
                {
                    text : Loc.g("Annuler"),
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
					text : Loc.g("Aller sur le produit parent"),
					click : function(){
						Utils.relocate("?_f=catalogueitem&id="+id+"&type="+type);

					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Vous devez passer par le produit parent pour activer les stocks."), options);
		
	},
	
	massswitchStockSerialWh: function(rowSelection){
	
		var options = {
			title	: Loc.g('Changement d’entrepôt groupé'),
			buttons	: [
                {
                    text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
                },
                {
					text	: Loc.g("Enregistrer"),
					click	: function(){
						$("#massswitchStockSerialWhForm").submit();
					}
				}
			],
			callback	: function(){
				var formId	= "massswitchStockSerialWhForm";
		
				var options = {
					data	: {
						action : 'recordmassswitchStockSerialWhForm'
					},
					success	: function(data){
						MyForm.processJson(data, "massswitchStockSerialWhForm");
						
						if(data.form.status!=="ok"){
							return false;
						} else {
							$('#popupWindow').dialog('close');
							Listing.update("stockserialsListing");

							var recap = data.recapTransaction;
							var msg = Loc.g("Opération réussie !");
							msg += "<br /><br /><strong>" + recap.total + "</strong> " + Loc.g('numéros de série traités');
							msg += "<br /><strong>" + recap.moved + "</strong> " + Loc.g('numéros de série déplacés');
							msg += "<br /><strong>" + recap.notmoved + "</strong> " + Loc.g('numéros de série non déplacés');

							var options = {
								type		: "confirm",
								resizable	: false,
								noclose		: true,
								title		: Loc.g("Déplacement d’entrepôt"),
								buttons		: [
									{
										text : Loc.g("Fermer"), 
										click : function(){
											$(this).dialog("close");
										}
									}
								]
							};

							MyWindow.alert(msg, options);

						}
					}, 
					dataType:"json"
				};

				MyForm.prepare(formId, "stock_ajax", options, true);
				MyFacture.initEvent();
			}
		};

		MyWindow.load("stock_ajax", {action:"massswitchStockSerialWhForm", rowSelection:rowSelection}, options);
	
	},
			
	recordmassswitchStockSerialWh: function(data){

		
		
	},

	massResetBooking: function(rowSelection){

		var options = {
			title	: Loc.g("Annulation des réservations de stock"),
			width	: 500,
			buttons	: [
                {
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Continuer"),
					click	: function(){
						$("#formListingItemBeforeMassAction").submit();
						$(this).dialog("close");
					}
				}
			],
			callback	: function(){
				Stock.prepareMassResetBooking('recordMassResetBooking', 'formListingItemBeforeMassAction');
			}
		};

		var params = {
			action		: "massResetBooking",
			rowSelection: rowSelection
		};

		MyWindow.load("catalogue", params, options);
	},

	prepareMassResetBooking: function(action, formId){

		action = (action === undefined) ? 'recordMassResetBooking' : action;
		formId = (formId === undefined) ? "massResetBooking" : formId;

		MyFacture.customForm();

		var options = {
			success	:function(data){
				var formIsOk = MyForm.processJson(data, "groupForm");
				if(formIsOk){
					Utils.reload();
				}
			}, 
			dataType:"json"
		};

		MyForm.prepare(formId, "catalogue&"+$.param({action:action}), options, true);

	},

	massStockSerialInOut: function(rowSelection, inOut){

		var title = Loc.g('Sortie de stock groupée');
		
		if (inOut === 'in'){
			title = Loc.g('Remise en stock groupée');
		}

		var options = {
			title	: title,
			buttons	: [
                {
                    text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
                },
                {
					text	: Loc.g("Enregistrer"), 
					click	: function(){
						$("#massstockSerialInOutForm").submit();
					}
				}
			],
			callback	: function(){
				Stock.preparemassstockSerialInOutForm();
			}
		};

		MyWindow.load("stock_ajax", {action:"massstockSerialInOutForm", rowSelection:rowSelection, inOut:inOut}, options);

	},


	preparemassstockSerialInOutForm: function(){
		
		var formId	= "massstockSerialInOutForm";
		var options = {
			dataType	:"json",
			data		: {
				action: 'recordmassstockSerialInOutForm'
			},
			success		: function(data){
				Stock.recordmassstockSerialInOutForm(data);
			}
		};
		
		MyForm.prepare(formId, "stock_ajax", options, true);
		MyFacture.initEvent();
		
	},
			
	recordmassstockSerialInOutForm: function(data){

		MyForm.processJson(data, "massstockSerialInOutForm");
		
		if(data.form.status!=="ok"){
			return false;
		} else {
			$('#popupWindow').dialog('close');
			Listing.update("stockserialsListing");
			
			var recap = data.recapTransaction;
			var msg = Loc.g("Opération réussie !");
			var title = Loc.g('Mouvements de stock');
			
			switch (recap.inOut) {
				
				case "in":
					title = Loc.g("Remise en stock groupée");

					msg += '<br /><br />'
					     + window.i18n.n__(
						     '%(nb)s numéro de série traité',
						     '%(nb)s numéros de série traités',
						     recap.total,
						     {'nb' : '<strong>' + recap.total + '</strong>'}
					     )
					     + '<br />'
					     + window.i18n.n__(
						     '%(nb)s numéro de série remis en stock',
						     '%(nb)s numéros de série remis en stock',
						     recap.moved,
						     {'nb' : '<strong>' + recap.moved + '</strong>'}
					     )
					     + '<br />'
					     + window.i18n.n__(
						     '%(nb)s numéro de série non remis en stock',
						     '%(nb)s numéros de série non remis en stock',
						     recap.notmoved,
						     {'nb' : '<strong>' + recap.notmoved + '</strong>'}
					     )
					;
					break;
					
				case "out":
					title = Loc.g("Sortie de stock groupée");

					msg += '<br /><br />'
					     + window.i18n.n__(
						     '%(nb)s numéro de série traité',
						     '%(nb)s numéros de série traités',
						     recap.total,
						     {'nb' : '<strong>' + recap.total + '</strong>'}
					     )
					     + '<br />'
					     + window.i18n.n__(
						     '%(nb)s numéro de série sorti du stock',
						     '%(nb)s numéros de série sortis du stock',
						     recap.moved,
						     {'nb' : '<strong>' + recap.moved + '</strong>'}
					     )
					     + '<br />'
					     + window.i18n.n__(
						     '%(nb)s numéro de série non sorti du stock',
						     '%(nb)s numéros de série non sortis du stock',
						     recap.notmoved,
						     {'nb' : '<strong>' + recap.notmoved + '</strong>'}
					     )
					;
					break;
			}
			
			
			var options = {
				type		: "confirm",
				resizable	: false,
				noclose		: true,
				title		: title,
				buttons		: [
					{
						text	: Loc.g("Fermer"), 
						click	: function(){
							$(this).dialog("close");
						}
					}
				]
			};

			MyWindow.alert(msg, options);
			
		}
		
	},
			
	
	switchStockSerialWh: function(serialid){
		var options = {
			title	: Loc.g('Changement d’entrepôt'),
			buttons	: [
                {
                    text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
                },
                {
					text	: Loc.g("Enregistrer"), 
					click	: function(){
						$("#switchStockSerialWhForm").submit();
					}
				}
			],
			callback	: function(){
				Stock.prepareswitchStockSerialWhForm();
			}
		};

		MyWindow.load("stock_ajax", {action:"switchStockSerialWhForm", serialid:serialid}, options);
	},
			
	prepareswitchStockSerialWhForm: function(){
		
		var formId	= "switchStockSerialWhForm";
		
		var options = {
			data	: {
				action: 'recordswitchStockSerialWhForm'
			},
			success	: function(data){
				Stock.recordswitchStockSerialWh(data);
			}, 
			dataType:"json"
		};
		
		MyForm.prepare(formId, "stock_ajax", options, true);
		MyFacture.initEvent();
		
	},		
		
	recordswitchStockSerialWh: function(data){
		
		MyForm.processJson(data, "switchStockSerialWhForm");
		
		if(data.form.status!=="ok"){
			return false;
		} else {
			
			$('#popupWindow').dialog('close');
			
			if ($('#itemstockserialsListing_searchEngine').length > 0){
				Listing.update('itemstockserialsListing');
			} else {
				Listing.update("stockserialsListing");
			}
			
		}
	},
	
	stockserialInOut: function(serialid, inOut){
		
		var options = {
			title	: inOut === "in" ? Loc.g('Entrée de stock') : Loc.g("Sortie de stock"),
			buttons	: [
                {
                    text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
                },
                {
					text : Loc.g("Enregistrer"), 
					click : function(){
						$("#stockSerialInOutForm").submit();
					}
				}
			],
			callback	: function(){
				Stock.preparestockserialInOutForm();
			}
		};

		MyWindow.load("stock_ajax", {action:"stockSerialInOutForm", serialid:serialid, inOut:inOut}, options);
	},
			
	preparestockserialInOutForm: function(){
		
		var formId	= "stockSerialInOutForm";
		var options = {
			data	: {
				action: 'recordstockSerialOutForm'
			},
			success	: function(data){
				Stock.recordstockserialInOut(data);
			}, 
			dataType: "json"
		};
		
		MyForm.prepare(formId, "stock_ajax", options, true);
		MyFacture.initEvent();
		
	},		
		
	recordstockserialInOut: function(data){

		MyForm.processJson(data, "stockSerialInOutForm");
		
		if(data.form.status!=="ok"){
			return false;
		} else {
			$('#popupWindow').dialog('close');
			
			if ($('#itemstockserialsListing_searchEngine').length > 0){
				Listing.update('itemstockserialsListing');
			} else {
				Listing.update("stockserialsListing");
			}
			
		}
		
	},
	
	switchMoveType: function(){
		
		$('#stockAdjustForm #stockDate').datepicker();
		$('#stockAdjustForm #stockDate').prop('readonly', false);
				
		switch ($('#stockAdjustForm #movetype option:selected').val()){
			
			case "inventory": 
				$('.pruchaseTr').fadeIn();
				$('.warehouseslist').fadeOut();
				
				$('#stockAdjustForm #stockDate').datepicker('destroy');
				$('#stockAdjustForm #stockDate').prop('readonly', true);
				
				switch($('#stockAdjustForm #stockDate').attr('format')) {
					default:
					case 'dmy':
						$('#stockAdjustForm #stockDate').val(Date.today().toString('dd/MM/yyyy'));
						break;
					case 'mdy':
						$('#stockAdjustForm #stockDate').val(Date.today().toString('MM/dd/yyyy'));
						break;
				}
				break;
			
			case "manual":
				$('.pruchaseTr').fadeIn();
				$('.warehouseslist').fadeOut();
				break;
				
			case "warehouse":
				$('.warehouseslist').fadeIn();
				$('.pruchaseTr').fadeOut();
				MyFacture.customForm();
				break;
		}

	},
	
	toggleMoreForItem: function(){

		$('.stock-toggle').slideToggle('normal', function(){
			MyFacture.customForm();
		});
		
	},
	
	disableStock: function(itemid){
		
		var msg =  Loc.g('Désactiver la gestion des stocks pour ce produit ?');
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Désactivation des stocks"),
			buttons		: [
				{
					text : Loc.g("Non"), click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui"), 
					click : function(){
						
						MyFacture.post(
							"stock_ajax", 
							{
								action	: "stockDesactivationForm",
								itemid	: itemid
							},
							function(data){
								Utils.reload();
							}, 
							"json"
						);

					}
				}
			]
		};

		MyWindow.alert(msg, options);
	},
	
	reenableStock: function(itemid){
		
		var msg =  Loc.g('Réactiver la gestion des stocks pour ce produit ?');
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Réactivation des stocks"),
			buttons		: [
				{
					text	: Loc.g("Non"),
					click	: function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Oui"), 
					click	: function(){
						MyFacture.post(
							"stock_ajax", 
							{
								action:"stockreactivationForm", 
								itemid:itemid
							}, 
							function(data){
								Utils.reload();
							},
							"json"
						);
					}
				}
			]
		};

		MyWindow.alert(msg, options);
	},

	chooseStockMethod : function(itemid){
		
		var options = {
			title	: Loc.g("Activation des stocks"),
			buttons	: [
				{
					text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.load("stock_ajax", {action:"stockActivationChooseMethod", itemid:itemid}, options);
		
	},
			
	enableStockSerialize: function(itemid){

		var options = {
			title	: Loc.g("Activation des stocks"),
			buttons	: [
                {
					text	: Loc.g("Annuler"), 
					'class'	: 'btn btn-default',
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Enregistrer"),
					'class'	: 'btn btn-primary',
					click	: function(){
						$("#stockActivationSerializeForm").submit();
					}
				}
			],
			callback	: function(){
				
				var formId	= "stockActivationSerializeForm";
				var options = {
					data : {
						action: 'recordActivationSerializeForm'
					},
					success:function(data){
						Stock.recordActivationForm(data);
					}, 
					dataType:"json"
				};

				MyForm.prepare(formId, "stock_ajax", options, true);
				MyFacture.initEvent();

				$('#stockActivationSerializeForm .rows-container').scrollTop($('#stockActivationSerializeForm .rows-container')[0].scrollHeight);

				Catalogue.listenDouchetteMode($(document), "Stock.addSerializedRow");

			}
		};

		MyWindow.load("stock_ajax", {action : "stockActivationSerializeForm", itemid : itemid}, options);

	},
	
	preparestockActivationSerializeForm: function(){

		
	},
			
	addSerializedRow: function(barCode){
		
		var nbRow = $('.rows-lists .one-row').length;
		var newRowIndex = nbRow + 1;
		var newRow = $('.rows-lists .one-default-row').clone();
		
		newRow.find('.warehouse')
				.attr('name', "row["+newRowIndex+"][whid]")
				.attr('id', "warehouse_"+newRowIndex);
		
		newRow.find('.barcode input')
				.attr('name', "row["+newRowIndex+"][barcode]")
				.attr('id', 'barcode_'+newRowIndex);
		
		newRow.find('.purchaseAmount input')
				.attr('name', "row["+newRowIndex+"][purchaseAmount]")
				.attr('id', 'purchaseAmount_'+newRowIndex);
		
		newRow.find('.rowindex')
				.attr('name', "row["+newRowIndex+"][rowid]")
				.attr('id', 'rowid_'+newRowIndex)
				.val(newRowIndex);
		
		newRow.attr('class', 'one-row');
		
		if (barCode !== undefined){
			newRow.find('.barcode input').val(barCode);
		}
				
		$('.rows-lists').append(newRow);
		$('.rows-container').scrollTop($('.rows-container')[0].scrollHeight);
		
		$('.no-barcodes').hide(); 
		
		MyFacture.customForm();
		
	},
			
	deleteSerializedRow: function(me){

		me.closest('tr').remove();
		
		if($('.rows-lists .one-row').length === 0){
			$('.no-barcodes').show(); 
		}
		
	},
			
	enableStock: function(itemid){
		
		var options = {
			title	: Loc.g("Activation des stocks"),
			buttons	: [
                {
					text	: Loc.g("Annuler"),
					'class'	: 'btn btn-default',
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Enregistrer"), 
					'class'	: 'btn btn-primary',
					click	: function(){
					$("#stockActivationForm").submit();
				}}
			],
			callback	: function(){
				var formId	= "stockActivationForm";
				var options = {
					data	: {
						action: 'recordActivationForm'
					},
					success	: function(data){
						Stock.recordActivationForm(data);
					},
					dataType:"json"
				};

				MyForm.prepare(formId, "stock_ajax", options, true);
				MyFacture.initEvent();
			}
		};

		MyWindow.load("stock_ajax", {action:"stockActivationForm", itemid:itemid}, options);
		
	},
	
	recordActivationForm: function (data) {

		MyForm.processJson(data, "stockActivationForm");
		
		if(data.form.status!=="ok"){
			return false;
		} else {
			Utils.reload();
		}
		
	},

	stockSettings: function(itemid){

		var options = {
			title	: Loc.g("Modifier les paramètres du stock"),
			width: 600,
			buttons	: [
                {
					text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Enregistrer"), 
					click	: function(){
						$("#stockSettingsForm").submit();
					}
				}
			],
			callback	: function(){
				var formId	= "stockSettingsForm";
				var options = {
					data	: {
						action: 'recordstockSettingsForm'
					},
					success	: function(data){

						MyForm.processJson(data, "stockSettingsForm");

						if(data.form.status!=='ok'){
							return false;
						} else {
							Utils.reload();
						}
					}, 
					dataType: "json"
				};

				MyForm.prepare(formId, "stock_ajax", options, true);
				MyFacture.initEvent();
			}
		};

		MyWindow.load("stock_ajax", {action:"stockSettingsForm", itemid:itemid}, options);
		
	},
	
	stockAdjust: function(itemid, declid){
		
		var options = {
			title		: Loc.g("Modifier le stock"),
			buttons		: [
                {
					text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Enregistrer"), 
					click : function(){
						$("#stockAdjustForm").submit();
					}
				}
			],
			callback	: function(){
				var formId	= "stockAdjustForm";
		
				var options = {
					data	: {
						action	: 'recordStockAdjust'
					},
					success:function(data){
						MyForm.processJson(data, "stockAdjustForm");

						if(data.form.status!=='ok'){
							if (data.form.msg !== '' && data.form.msg !== undefined){
								MyWindow.alert(data.form.msg, {type: 'error'});
							}
							return false;
						} else {
							if ($('#itemsListing_searchEngine').length > 0){
								MyWindow.close();
								Listing.update('itemsListing');
							} else {
								Utils.reload();
							}
						}
					}, 
					dataType:"json"
				};

				MyForm.prepare(formId, "stock_ajax", options, true);
				MyFacture.initEvent();
			}
		};

		MyWindow.load("stock_ajax", {action:"stockAdjustForm", itemid:itemid, declid: declid}, options);
		
	},
	
	
	resetBooking: function(itemid, declid){
	
		var options = {
			type	: 'warning',
			title	: Loc.g('Annuler les réservations'),
			width	: 500,
			buttons	: [
                {
					text	: Loc.g('Ne rien faire'), 
					'class' : 'btn btn-cancel', 
					click	: function(){
						$(this).dialog('close');
					}
				},
                {
					text	: Loc.g('Annuler les réservations'), 
					click	: function(){

						MyFacture.post(
							"stock_ajax", 
							{
								action	: "resetBooking",
								itemid	: itemid,
								declid	: declid
							}, 
							function(data){
								Utils.reload();
							}, 
							'json'
						);
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Vous allez supprimer l’ensemble des réservations pour ce produit et remettre la quantité réservée à zéro. <br /> <br /> Cette action est irréversible, voulez-vous continuer ?"), options);
		
	},
	
	stockAddSerials: function(itemid, declid){

		var options = {
			title	: Loc.g("Ajouter des entrées sérialisées"),
			buttons	: [
                {
					text	: Loc.g("Annuler"), 
					click	: function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Enregistrer"),
					click	: function(){
						$("#stockAddSerialsForm").submit();
					}
				}
			],
			callback	: function(){
				Stock.preapreStockAddSerialsForm();
			}
		};

		MyWindow.load("stock_ajax", {action:"stockActivationSerializeForm", itemid:itemid, declid:declid, addSerials:'Y'}, options);
		
	},
	
	preapreStockAddSerialsForm: function(){

		var formId	= "stockAddSerialsForm";
		var options = {
			data	: {
				action		: 'recordActivationSerializeForm', 
				addSerials	:'Y'
			},
			success	:function(data){
				Stock.recordAddSerialForm(data);
			}, 
			dataType:"json"
		};
		
		MyForm.prepare(formId, "stock_ajax", options, true);
		MyFacture.initEvent();
		
		$('#stockAddSerialsForm .rows-container').scrollTop($('#stockAddSerialsForm .rows-container')[0].scrollHeight);
		
		Catalogue.listenDouchetteMode($(document), "Stock.addSerializedRow" );
		
	},
	
	recordAddSerialForm : function (data) {

		MyForm.processJson(data, "stockAddSerialsForm");
		
		if(data.form.status!=="ok"){
			if (data.form.msg !== ""){
				MyWindow.alert(data.form.msg, {type:'warning'});
			}
			
			return false;
		} else {
			Utils.reload();
		}
		
	}
	
};

window.StockWareHouse = {
	
	initWarehousepref: function(){
		
		$('#defaultwarehouse').on("change", function(data){
			
			var selected	= $(this).find("option:selected").val();
			var data		= {action:"warehouseDefault", whid:selected};
			
			MyFacture.post(
				"stock_prefs", 
				data, 
				function(data){
					Utils.reload();
				}, 
				"json"
			);
			
		});
	},
	
	deleteOne: function(whid){
		
		var msg =  Loc.g('Êtes-vous sûr de vouloir supprimer cet entrepôt ?');
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression"),
			buttons		: [
				{
					text : Loc.g("Non"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Oui"), 
					click	: function(){
						MyFacture.post(
							"stock_prefs", 
							{
								action	: "warehouseDelete", 
								whid	: whid
							}, 
							function(data){
								Utils.reload();
							},
							"json"
						);
					}
				}
			]
		};

		MyWindow.alert(msg, options);
		
	},
	
	editOne: function(whid){
		
		var options = {
			title	: Loc.g("Modifier un entrepôt"),
			buttons	: [
                {
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text	: Loc.g("Enregistrer"), 
					click	: function(){
						$("#warehouseForm").submit();
					}
				}
			],
			callback	: function(){
				StockWareHouse.preparewarehouseForm();
			}
		};

		MyWindow.load("stock_prefs", {action:"warehouseForm", whid:whid}, options);
		
	},
	
	addOne : function(){
		var options = {
			title	: Loc.g("Ajouter un entrepôt"),
			buttons	: [
                {
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
                {
					text : Loc.g("Ajouter"), 
					click : function(){
						$("#warehouseForm").submit();
					}
				}
			],
			callback	: function(){StockWareHouse.preparewarehouseForm();}
		};

		MyWindow.load("stock_prefs", {action:"warehouseForm"}, options);
	},
	
	preparewarehouseForm: function(){
		
		var formId	= "warehouseForm";
		var options = {
			data	: {
				action	: 'warehouseRecord'
			},
			success	: function(data){
				MyForm.processJson(data, "warehouseform");

				if(data.form.status !== 'ok'){
					return false;
				} else {
					Utils.reload();
				}
			}, 
			dataType:"json"
		};
		
		MyForm.prepare(formId, "stock_prefs", options, true);
		MyFacture.initEvent();
		
	}
};

window.StockDocOverview = {
	
	
	viewTabDocChildsMove: function(docid, doctype){
		
		MyFacture.post(
			"stock_ajax", 
			{
				action	:'viewDocChildsMove', 
				tabview : 'Y', 
				docid	:docid,
				doctype	:doctype
			}, 
			function(data){
				$('#stocks_content').html(data.stockMoves);
				Qtip.init();
			}, 
			'json'
		);

		
	},

	viewMoves: function(docid, doctype, oldid){
		
		oldid = oldid === undefined ? 0 : oldid;
		
		var options = {
			title	: Loc.g("Voir les mouvements de stocks"),
			width	: 650,
			buttons	: [
				{
					text : Loc.g("Fermer"), 
					click : function(){
						$(this).dialog("close");
					}
				}
			],
			callback: function(){
				Qtip.init();
			}
		};

		MyWindow.load("stock_ajax", {action:'viewDocMove', docid:docid, doctype:doctype, oldid:oldid}, options);
		
	},
	
	lodTabMoves: function(docid, doctype, oldid){
		
		oldid = oldid === undefined ? 0 : oldid;
		
		MyFacture.post(
			"stock_ajax", 
			{
				action	:'viewDocMove', 
				tabview : 'Y', 
				docid	:docid, 
				doctype	:doctype, 
				oldid	:oldid
			}, 
			function(data){
				$('#stocks_content').html(data.stockMoves);
				Qtip.init();
			}, 
			'json'
		);
		
	},
	
	impactStocks: function(docid) {		
		var options = {
			dialogClass : "white",
			title	: Loc.g("Impacter les stocks"),
			buttons	: [
				{
					text	: Loc.g("Non"),
					click	: function() {
						$(this).dialog('close');
					}
				},
				{
					text	: Loc.g("Oui"),
					click	: function() {
						MyFacture.post('stock_ajax', 
						{
							action	: 'impactStockOnDocument',
							docid	: docid
						}, 
						function(data) {
							Utils.reload();
						}, 
						'json');
					}
				}
			]
		};
		MyWindow.alert(Loc.g('Voulez-vous vraiment impacter les stocks sur ce document ?'), options);
	}
};

window.StockDocForm = {
	
	checkQt: function(){
		
		var datas = {
			action	: 'checkDocForm',
			form	: $('#docForm').serialize(),
			impact	: $('#stockImpact').prop('checked')
		};

		MyFacture.post("stock_ajax", datas, function(data){

			if (data.stockRecap === undefined || (data.stockRecap !== undefined && data.stockRecap === 0)){
				MyForm.canSubmit = true;
				$('#generatePurchase').val('N');
				$('#checkstock').val('N');
				DocFormv2.record();
				
			} else {
				
				var options = {
					noclose	: true,
					closeOnEscape: false,
					width	: 1200,
					title	: Loc.g("Récapitulatif du stock"),
					buttons	: []
				};

				MyWindow.alert(data.docFormAlert, options);

				if ($('#stockImpact').is(':checked')) {
					
					var excludedDoctypes		= ['creditnote'];
					var excludedParentDoctypes  = ['estimate', 'order'];
					
					if($('#parentStockImpact').val() === 'Y' && !Utils.in_array($('#parentDocType').val(), excludedParentDoctypes) && !Utils.in_array($('#doctype').val(), excludedDoctypes)) {
						$("[name='radio_stockImpact']").filter('[value="N"]').attr('checked', true);
					} else {
						$("[name='radio_stockImpact']").filter('[value="Y"]').attr('checked', true);
					}
					
				} else {
					$("[name='radio_stockImpact']").filter('[value="N"]').attr('checked', true);
				}

				if ($('#stockImpact_N').is(':checked')) {
					$('.resume-impact').hide();
				}

				$("[name='radio_stockImpact']").click(function(event) {
					// Hide resume impact table if impact stock is in N
					if ($(this).val() == 'N') {
						$('.resume-impact').hide();
					}
					else if($(this).val() == 'Y'){
						$('.resume-impact').show();
					}

					// si pas de ligne d'erreur, rien à faire, c'est déjà tout bon ;)
					if($('#cmup,#serial').find('tr.error-line').length === 0) {
						return;
					}
					
					var isLocked = false;
					$('#cmup,#serial').find('tr.error-line').each(function() {
						var error = $(this).find('td.errorMessage');
						if(error.data('canlock') === 'Y') {
							isLocked = true;
						}
					});

					if($("[name='radio_stockImpact']:checked").val() === 'Y') {
						if($('#isLockToSave').val() === 'Y') {
							$('#hiddenValidButton').hide();
						} else {
							if(isLocked) {
								$('#hiddenValidButton').hide();
							} else {
								$('#hiddenValidButton').show();
							}
						}
					} else {
						if(isLocked) {
							$('#hiddenValidButton').hide();
						} else {
							$('#hiddenValidButton').show();
						}
					}
				});
				$("[name='radio_stockImpact']:checked").trigger('click');
			}
			
		}, "json");

		return false;

	},
	
	recordCheckQt: function(todo){
		
		var stockImpact = $("[name='radio_stockImpact']:checked").val();
		
		if (stockImpact === "Y"){
			$('#stockImpact').prop('checked', true);
		} else {
			$('#stockImpact').prop('checked', false);
		}
		
		if ($('#stockImpact').hasClass('ui-helper-hidden-accessible')){
			$('#stockImpact').button('refresh');
		}
		
		MyFacture.stopWait();
		$('#alertWindow').dialog('close');
		MyForm.canSubmit = true;
		
		switch (todo) {
			
			case "edit":
				$('#generatePurchase').val('N');
				$('#checkstock').val('Y');
				break;
				
			case "simplegen":
				$('#generatePurchase').val('N');
				$('#checkstock').val('N');
				DocFormv2.record();
				break
				
		}
	}
};

window.StockMovesListing = {
	
	prepareFilterForm: function(){
		
        var options = {
			data	: {
				action : "updateListing"
			},
			success	: function(data){
				StockMovesListing.processFilterForm(data);
			}, 
			dataType:"json"
		};
        MyForm.prepare("stockmovesFilterForm", "stock_moveslisting", options);
		
	},
	
	processFilterForm: function(data){

		Listing.refresh("stockmovesListing", data, data.stockmoves_metadatas);		
		$('.statBlock:visible').nanoScroller({preventPageScrolling: true});
		
	},
	
	buildPagenum: function(pagenum, nbpage){}
	
};

window.StockSerialsListing = {
	
	prepareFilterForm: function(){
		
        var options = {
			data	: {
				action	: 'updateListing'
			},
			success:function(data){
				StockSerialsListing.processFilterForm(data);
			}, 
			dataType:"json"
		};
		
        MyForm.prepare("stockserialsFilterForm", "stock_serialslisting", options);
		Catalogue.listenDouchetteMode($(document), "StockSerialsListing.searchBc");
		
	},
			
	searchBc: function(bc){
		
		$('#stockserialsFilterForm #stockserialsListing_filter_barcode').val(bc);
		Listing.update('stockserialsListing');
		$('#stockserialsListing_filter_barcode').parent().slideToggle();
		
	},
	
	processFilterForm: function(data){

		Listing.refresh("stockserialsListing", data, data.stockserials_metadatas);		
		$('.statBlock:visible').nanoScroller({preventPageScrolling: true});
		
	},
	
	buildPagenum: function(pagenum, nbpage){}
	
};
